import { faEyeSlash } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";




export const NoRecordsMessage = () => {

    const { t, i18n } = useTranslation();

    return (
        <Grid container alignItems="center" spacing={3}>
            <Grid item xs={12}>
                <Typography align="center" variant="h6">
                    <FontAwesomeIcon icon={faEyeSlash} /> {t('label-no-records')}
                </Typography>
            </Grid>
        </Grid>
    );

};